import { loginPath, privacyPath, termsPath } from "../../constants.ts";
import { posts } from "./blogData.ts";

export const blogPath = "/blog";
export const botsPath = "/bots";
export const chatPath = "/chat";
export const builderChatPath = chatPath;
export const settingsPath = "/settings";
export const profilePath = "/profile";
export const mentatPath = "/mentat";
export const automationPath = "/automation";
export const businessPath = "/business";
export const agenticUiPath = "/agentic-ui";
export const autoLandingPath = "/auto-landing";
export { loginPath, privacyPath, termsPath };

export const prerenderedRoutes = [
  "/",
  "/debug",
  "/blog",
  ...posts.map(({ slug }) => `/blog/${slug}`),
  "/docs",
  "/pricing",
  "/settings",
  "/profile",
  privacyPath,
  termsPath,
  "/refund-policy",
  "/about",
  "/talk-to-skill",
  "/agency",
  "/templates",
  "/admin",
  "/demo-numbers",
  mentatPath,
  automationPath,
  businessPath,
  agenticUiPath,
  autoLandingPath,
];
